import React from 'react';
import InstituteCrudPage from './InstituteCrudPage';
import { entityConfigs } from '../../config/entityConfigs';

export default function QuestionBanksPage() {
  return <InstituteCrudPage config={entityConfigs['question-banks']} />;
}
